import { Action } from "redux"

import * as actions from "./actions"
import { INotifications } from "./index"

export const initialState: INotifications = {
    messages: [],
}

const ACTION_HANDLERS: {
    [action: string]: (state: INotifications, props: Action) => INotifications
} = {
    [actions.ADD_MESSAGE]: (
        state,
        { message }: actions.NotificationMessage,
    ): INotifications => ({
        ...state,
        messages: [message, ...state.messages],
    }),

    [actions.OVERWRITE_PREVIOUS_MESSAGE]: (
        state,
        { message }: actions.NotificationMessage,
    ): INotifications => {
        // we have to make sure that the previous message is not part of the messages
        // as we have to override that
        const [_previousMessage, ...otherMessages] = state.messages
        return {
            ...state,
            messages: [message, ...otherMessages],
        }
    },

    [actions.APPEND_PREVIOUS_MESSAGE]: (
        state,
        { message }: actions.NotificationMessage,
    ): INotifications => {
        const [previousMessage, ...otherMessages] = state.messages
        return {
            ...state,
            messages: [
                {
                    ...previousMessage,
                    content: `${previousMessage.content}\n${message.content}`,
                    isContentHtml:
                        previousMessage.isContentHtml || message.isContentHtml,
                },
                ...otherMessages,
            ],
        }
    },

    [actions.EXPAND]: (
        state,
        { id, expanded }: actions.NotificationMessageExpand,
    ): INotifications => {
        return {
            ...state,
            messages: state.messages.map((m) => {
                if (m.uuid === id) {
                    m.isExpanded = expanded
                }
                return m
            }),
        }
    },

    [actions.FLASH]: (
        state,
        { isFlashing }: actions.NotificationMessageFlash,
    ): INotifications => {
        const [previousMessage, ...otherMessages] = state.messages
        return {
            ...state,
            messages: [
                {
                    ...previousMessage,
                    isFlashing,
                },
                ...otherMessages,
            ],
        }
    },

    [actions.REMOVE_ALL_MESSAGES]: (state): INotifications => {
        return {
            ...state,
            messages: [],
        }
    },

    [actions.REMOVE_MESSAGE]: (
        state,
        { message: { uuid } }: actions.NotificationMessage,
    ): INotifications => {
        return {
            ...state,
            messages: state.messages.filter((x) => x.uuid !== uuid),
        }
    },
}

export default function reducer(
    state = initialState,
    action: Action,
): INotifications {
    const handler: (state: INotifications, action: Action) => INotifications =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
